// @ts-nocheck
import { combineReducers } from 'redux';
import siderMenu from './sider-menu';
import reports from './reports';
import logs from './logs';
import global from './global';
import general from './general';
import mbn from './mbn';
import bat from './bet-acceptance-time';
import marketGroup from './market-group';
import monitoring from './monitoring';
import staticData from './static-data';
import socket from './socket';
import users from './users';
import auth from './auth';
import messages from './messages';
import gamingActivity from './gaming-activity';
import transactions from './transactions';
import emails from './email';
import settlement from './settlement';
import quickSearch from './quick-search';
import combinationLock from './combination-lock';
import storage from 'redux-persist/lib/storage';
import storageSession from 'redux-persist/lib/storage/session';
import persistReducer from 'redux-persist/es/persistReducer';
import columns from './columns';
import pagination from './pagination';
import payment from './payment';
import autoMergeLevel2 from 'redux-persist/lib/stateReconciler/autoMergeLevel2';
import weight from './weight';
import serverErrors from './server-errors';
import playerSearch from './player-search';
import permissionsGroups from './permissionsGroups';
import translations from './translations';
import accountingReport from './accounting-report';
import loginsHistory from './logins-history';
import couponBanner from './banners/coupon-banner';
import betBanner from './banners/bet-banner';
import banners from './banners/banners';
import promotionBanner from './banners/promotion-banner';
import featuredLinks from './featured-links';
import playerActivityReport from './playerActivityReport';
import taxReport from './tax-report';
import onlineReports from './online-reports';
import netCashReport from './net-cash-report';
import player from './player';
import bonus from './bonus';
import savedFilters from './saved-filters';
import notifications from './notifications';
import bettingRules from './betting-rules';
import cashoutBlock from './cashout-block';
import marketDescriptions from './market-descriptions';

const columnsPersistConfig = {
    key: 'columns',
    storage,
    stateReconciler: autoMergeLevel2,
};

const globalPersistConfig = {
    key: 'global',
    storage: storageSession,
    whitelist: ['translationMode'],
    stateReconciler: autoMergeLevel2,
};

const filtersPersistConfig = {
    key: 'savedFilters',
    storage,
    stateReconciler: autoMergeLevel2,
};

const rootReducer = combineReducers({
    accountingReport,
    auth,
    banners,
    bat,
    betBanner,
    bonus,
    columns: persistReducer(columnsPersistConfig, columns),
    combinationLock,
    couponBanner,
    emails,
    featuredLinks,
    gamingActivity,
    general,
    global: persistReducer(globalPersistConfig, global),
    loginsHistory,
    logs,
    marketGroup,
    mbn,
    messages,
    monitoring,
    netCashReport,
    onlineReports,
    pagination,
    payment,
    permissionsGroups,
    player,
    playerActivityReport,
    playerSearch,
    promotionBanner,
    quickSearch,
    reports,
    savedFilters: persistReducer(filtersPersistConfig, savedFilters),
    serverErrors,
    settlement,
    siderMenu,
    socket,
    staticData,
    taxReport,
    transactions,
    translations,
    users,
    weight,
    notifications,
    bettingRules,
    cashoutBlock,
    marketDescriptions,
});

export default rootReducer;
